import { SelectedAddons } from '../types';
import { FormService } from '../../mappers/serviceMapper/service.mapper';
import {
  QueryAddOnsResponse,
  AddOn,
} from '@wix/ambassador-addons-v1-add-on/types';
import { MultiAddonsInfo } from '@wix/bookings-uou-types';

export const initiateSelectedAddonsState = ({
  addonsInfoPreSelection,
  service,
  preSelectedAddons,
}: {
  addonsInfoPreSelection?: MultiAddonsInfo[];
  service: FormService;
  preSelectedAddons?: QueryAddOnsResponse;
}): SelectedAddons | undefined => {
  if (!addonsInfoPreSelection?.length || !preSelectedAddons?.addOns?.length) {
    return undefined;
  }

  const serviceAddonsInfo = addonsInfoPreSelection.find(
    (info) => info.serviceId === service.id,
  );

  if (!serviceAddonsInfo) {
    return undefined;
  }

  return serviceAddonsInfo.addonsInfo.reduce<SelectedAddons>(
    (acc, groupInfo) => {
      groupInfo.addons.forEach((addon) => {
        const preSelectedAddon = preSelectedAddons.addOns?.find(
          (preSelected: AddOn) => preSelected.id === addon.id,
        );

        if (preSelectedAddon) {
          acc[addon.id] = {
            id: addon.id,
            quantity: addon.quantity,
            groupId: groupInfo.groupId,
            durationInMinutes: preSelectedAddon.durationInMinutes,
            price: preSelectedAddon.price?.value,
            currency: preSelectedAddon.price?.currency || 'USD',
          };
        }
      });
      return acc;
    },
    {},
  );
};
